import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportInvoiceListFilters, getReportInvoiceListAction } from "redux/actions/Reports/reportInvoiceList/reportInvoiceListActions";

export const ReportInvoiceListView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportInvoiceList }) => reportInvoiceList);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInvoiceListAction({ startDate, endDate, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInvoiceListAction({ startDate, endDate, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte Listado Facturación" icon={<ReceiptIcon />}>
      {isLoadingComp?.loadingReportInvoiceList ? <LoadingComponent /> :
        <TableInputs
          reducer="reportInvoiceList"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportInvoiceListFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
